export const isValidEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
export const validateEmail = value => {
    return !!(value && value.match(isValidEmail));
}

export const isNotEmpty = value => value != '';

